var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sobre"}},[_c('b-row',{staticClass:"tituloPaginaRow",style:(_vm.tituloRowBG)},[_c('h1',{staticClass:"tituloPagina"},[_vm._v("\n      "+_vm._s(_vm.tituloPagina)+"\n    ")])]),_vm._v(" "),_c('b-row',{staticClass:"p-3 p-sm-0 p-md-0 p-lg-0 p-xl-0"},[_c('p',{class:_vm.justifiedText,domProps:{"innerHTML":_vm._s(_vm.textoSobre)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd673ea8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sobre.vue
// module id = zmmJ
// module chunks = 1